module.exports = __webpack_public_path__ + "static/media/dj.3d05b326.svg";